import React, { FC, useState } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useGetPayload } from '~/controllers/wizard';
import { FormItemInjectedProps } from '~/types/FormItemInjectedProps';
import { KsaShareholders } from '~/types/ksa/KsaShareholders';
import BeneficialOwnerTable, {
  getBeneficialOwnerData,
} from '~/pages/ksa/application/shareholders/components/beneficialOwners/BeneficialOwnerTable';
import BeneficialOwnerReviewEdit from './BeneficialOwnerReviewEdit';

const BeneficialOwnerReviewTableForm: FC<Partial<FormItemInjectedProps<KsaShareholders>>> = (
  props
) => {
  const payload = useGetPayload();
  const shareholders = { shareholders: payload?.shareholders };

  const { t } = useTranslation('ksaReview');

  const [editId, setId] = useState('');
  const openEdit = (uid: string) => {
    setId(uid);
  };
  const closeEdit = () => {
    setId('');
  };

  const beneficialOwnersDataSource = getBeneficialOwnerData(shareholders, openEdit);

  return (
    <>
      {editId && <BeneficialOwnerReviewEdit uid={editId} onClose={closeEdit} {...props} />}
      <Typography.Title level={4}>{t('Beneficial owners').toUpperCase()}</Typography.Title>
      <BeneficialOwnerTable beneficialOwners={beneficialOwnersDataSource} />
    </>
  );
};

export default BeneficialOwnerReviewTableForm;
